import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AppMasterService } from 'app/business/service/app/app-master.service';
import { ConfirmPopupComponent } from '../../confirm-popup/confirm-popup.component';
import { AlertMessageService } from '@bundle/component/alert-message/alert-message.service'

@Component({
  selector: 'app-weight-control-popup-inquiry',
  templateUrl: './weight-control-popup-inquiry.component.html',
  styleUrls: ['./weight-control-popup-inquiry.component.scss']
})
export class WeightControlPopupInquiryComponent implements OnInit {
  form: any = {};
  itemList: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    public dialogRef: MatDialogRef<WeightControlPopupInquiryComponent>,
    private appMasterService: AppMasterService,
    private dialog: MatDialog,
    private alertMessageService: AlertMessageService
  ) {
    if (data) {
      this.form = data;
    } else {
      this.form.isActive = 'Y';
      this.form.qtyNone = 'Y';
    }
    
  }
  ngOnInit(): void {
    const data = {
      "code": this.form.code,
    };
    this.appMasterService.getListWeight(data).then((res: any) => {
      if (res === "error") {
        return;
      } else {
        this.itemList = res;
        
      }
    });
  }

  save() {
    
    if (this.form.code !== undefined && this.form.code !== null && this.form.code !== "") {
      const data = {
        "name": this.form.name,
        "code": this.form.code,
        "desc": this.form.desc,
        "qtyNone": this.form.qtyNone,
        "isActive": this.form.isActive
      };
      this.appMasterService.saveWeight(data).then((res: any) => {
        if (res === "error") {
          this.alertMessageService.open({message: "บันทึกข้อมูลไม่สำเร็จ", title:""});
        } else {
          this.dialogRef.close();
          this.alertMessageService.open({message: "บันทึกข้อมูลสำเร็จ", title:""});
        }
      });
    } else {
      this.alertMessageService.open({message: "กรุณากรอกข้อมูลให้ครบ", title:"ข้อผิดพลาด"});
    }
  }

  onChange(e) {
    if (e.checked == true) {
      this.form.isActive = "Y";
    } else {
      this.form.isActive = "N";
    }
  }

  qtyonChange(e) {
    if (e.checked == true) {
      this.form.qtyNone = "Y";
    } else {
      this.form.qtyNone = "N";
    }
  }

  endPopup(e) {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      disableClose: false,
      // width: '30vw',
      data: {
        header: e,
        button: 'close'
      },
      maxWidth: 'none'
    });

    dialogRef.afterClosed().subscribe(res => {
      this.dialogRef.close();
    });
  }

}
